module.exports = __webpack_public_path__ + "static/media/18ECA15.92fe7286.jpg";